<template>
    <footer class="mdl-mini-footer">
        <div class="footer-content">
            This project is developed by
            <a href="https://theananda.org" target="_blank"><img src="../../assets/images/logo.png" height="50" width="50" alt="The Ānanda">The Ānanda</a>
            and funded by 
                <a href="https://www.od4d.net/" target="_blank">
                <img src="https://www.od4d.net/images/od4d-logo-color.svg" alt="OD4D" height="50px">
            </a> 
        </div>
        
    </footer>
</template>

<script>
    

export default {
    name: 'Footer'
}

</script>